import { Injectable, signal } from '@angular/core';

export interface ThemeOption {
  id: string;
  label: string;
  className: string;
}

@Injectable({ providedIn: 'root' })
export class ThemeService {
  readonly themes: ThemeOption[] = [
    { id: 'orange', label: 'Orange', className: 'theme-orange' },
    { id: 'blue', label: 'Blue', className: 'theme-blue' },
    { id: 'purple', label: 'Purple', className: 'theme-purple' },
  ];

  readonly activeTheme = signal<ThemeOption>(this.themes[0]);

  constructor() {
    const saved = localStorage.getItem('clm4sp-theme');
    if (saved) {
      const found = this.themes.find(t => t.id === saved);
      if (found) this.activeTheme.set(found);
    }
    this.applyTheme(this.activeTheme());
  }

  setTheme(theme: ThemeOption): void {
    this.activeTheme.set(theme);
    localStorage.setItem('clm4sp-theme', theme.id);
    this.applyTheme(theme);
  }

  get availableThemes(): ThemeOption[] {
    const current = this.activeTheme();
    return this.themes.filter(t => t.id !== current.id);
  }

  private applyTheme(theme: ThemeOption): void {
    const body = document.body;
    this.themes.forEach(t => body.classList.remove(t.className));
    body.classList.add(theme.className);
  }
}
